import React, { useCallback } from 'react'
import RadioButtonContainer from '../radioButton/radioButtonContainer'
import RadioButton from '../radioButton/radioButton'
import Svg from '../svg/svg'
import { LayoutButtonsProps } from './types'
import { capitalize } from '../../../utils/functions'

const LayoutButtons = ({
   layoutOptions,
   selectedLayout,
   handleButtonClick,
   isDisabled,
}: LayoutButtonsProps): JSX.Element => {
   const getCheckedValue = useCallback(
      (type: string) =>
         type === 'cards'
            ? type === selectedLayout || !selectedLayout
            : type === selectedLayout,
      [selectedLayout]
   )

   return (
      <RadioButtonContainer variant="icons" id={''} groupName={''}>
         {layoutOptions.map((layout, index) => (
            <RadioButton
               id={`radioIcon${index}`}
               groupName="radioIconGroup"
               variant="icon"
               key={layout.type}
               checked={getCheckedValue(layout.type)}
               action={() => handleButtonClick(layout.view)}
               disabled={isDisabled}
               tooltip={`${capitalize(layout.type)} view`}
            >
               <Svg
                  id={layout.type}
                  height={25}
                  width={layout.type === 'map' ? 25 : 37}
               />
            </RadioButton>
         ))}
      </RadioButtonContainer>
   )
}

export default LayoutButtons
